import React, { useCallback, useRef, useState } from "react";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import { ForeignData_API } from "../../../APIs/ForeignData.api";
import FileImageUpdate from "../../../cpn/inputs/file-image-update";
import { Table } from "react-bootstrap";
import { components } from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

export default function RenderInputsLXH({
  field: f,
  options,
  selectedValues,
  setSelectedValues,
  control,
  register,
  setValue,
  getValues,
  isChild,
  refresh,
  dataSuggest,
  showDataSuggest,
  setShowDataSuggest,
  setDataSuggest,
  isDisabled,
  setDisabled,
  dataTable,
  setDataTables,
  isCreate,
  isUpdate,
}) {
  const { lang, proxy, functions } = useSelector((state) => state);
  const { filterData } = functions;
  const {
    type,
    alias,
    readOnly,
    table_id,
    displayFields,
    style,
    name,
    required,
    betChar,
    isPK,
    isMulti,
    isButton,
    isModal,
    isApi,
    isTable,
    isClone,
  } = f;
  const [clones, setClones] = useState([]);
  const value = getValues(alias);
  const details = dataTable || [];
  console.log("dataTabledataTable", dataTable);
  const CustomOption = ({ children, ...props }) => {
    return (
      <>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: 10 }}
          />
          {children}
        </components.Option>
      </>
    );
  };
  switch (type) {
    case "input-select":
      return (
        <div>
          {isChild && (
            <label
              class="form-label"
              style={{
                position: "absolute",
                top: "-27px",
                right: "-5px",
              }}
            >
              {name}
              {required && <span style={{ color: "red" }}>*</span>}
            </label>
          )}
          <select
            className="form-control"
            aria-label="Default select example"
            {...register(alias)}
            value={value}
            style={style}
          >
            <option></option>
            {options.length &&
              options.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>
      );

    case "select":
      return (
        <Controller
          name={alias}
          control={control}
          defaultValue=""
          render={({ field }) => {
            return (
              <>
                <div className="d-flex justify-content-between">
                  <AsyncPaginate
                    name={field.name}
                    onBlur={field.onBlur}
                    className="mb-0 w-100"
                    isDisabled={isDisabled?.[alias]}
                    loadOptions={async (search, loadedOptions, { page }) => {
                      return await loadOptions(
                        page,
                        search,
                        displayFields,
                        table_id,
                        proxy,
                        isPK,
                        isApi,
                        isClone
                      );
                    }}
                    value={selectedValues?.[alias] || null}
                    onChange={(opt) => {
                      if (isMulti || isModal?.id) {
                        setSelectedValues((prev) => {
                          const newPrev = { ...prev };
                          newPrev[alias] = opt.map((item) => ({
                            label: item?.label,
                            value: item?.value,
                            ...item,
                          }));
                          return newPrev;
                        });
                        if (isModal?.id) {
                          setDataSuggest((prev) => {
                            const newPrev = { ...prev };
                            newPrev["2LGH"] = opt;
                            return newPrev;
                          });
                          setShowDataSuggest(true);
                        }
                        setValue(
                          alias,
                          opt.map((item) => item?.value)
                        );
                        setDataTables((prev) => {
                          const prevIds = prev.map((d) => d.mathanhpham);
                          const optIds = opt.map((o) => o.value);

                          const added = opt.filter(
                            (o) => !prevIds.includes(o.value)
                          );

                          const removed = prev.filter(
                            (d) => !optIds.includes(d.mathanhpham)
                          );

                          const stillExist = prev.filter((d) =>
                            optIds.includes(d.mathanhpham)
                          );

                          const newPrev = [
                            ...stillExist,
                            ...added.map((item) => ({
                              delivery_detail_id: `D${Math.floor(
                                100000 + Math.random() * 900000
                              ).toString()}`,
                              mathanhpham: item?.["22MSP"],
                              tenthanhpham: item?.["10TSP"],
                            })),
                          ];

                          return newPrev;
                        });
                      } else {
                        setValue(alias, opt?.value);

                        setSelectedValues((prev) => {
                          const newPrev = { ...prev };
                          newPrev[alias] = {
                            label: opt?.label,
                            value: opt?.value,
                            ...opt,
                          };
                          return newPrev;
                        });
                        if (dataSuggest) {
                          setDataSuggest((prev) => {
                            const newPrev = { ...prev };
                            newPrev["2LGH"] = [opt];
                            return newPrev;
                          });
                          setShowDataSuggest(true);
                        }
                      }
                    }}
                    additional={{ page: 0 }}
                    isSearchable={true}
                    allowCreateWhileLoading={false}
                    noOptionsMessage={() => (
                      <div style={{ fontWeight: "300" }}>
                        {lang["not found data"]}
                      </div>
                    )}
                    isClearable={true}
                    styles={{
                      menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    isMulti={isMulti}
                    closeMenuOnSelect={isMulti && false}
                    components={{
                      Option: isMulti ? CustomOption : components.Option,
                    }}
                    placeholder={lang["select value"]}
                  />
                  {isTable && (
                    <button
                      className="btn btn-success ml-3 mt-0"
                      type="button"
                      onClick={() => {
                        if (clones) {
                          setDataTables((prev) => {
                            const newPrev = [...prev];
                            const doubled = [
                              ...newPrev,
                              ...newPrev
                                .filter((_, index) => clones[index])
                                .map((item) => ({
                                  ...item,
                                  delivery_detail_id: `D${Math.floor(
                                    100000 + Math.random() * 900000
                                  ).toString()}`,
                                  soluongcanxuat: 0,
                                })),
                            ];
                            doubled.sort((a, b) => {
                              return a.mathanhpham.localeCompare(b.mathanhpham);
                            });
                            return doubled;
                          });
                          setClones({});
                        }
                      }}
                    >
                      Thêm
                    </button>
                  )}
                </div>
                {isTable && (
                  <div
                    className=" mt-3"
                    style={{
                      overflow: "auto",
                      height:
                        dataTable?.details?.length &&
                        dataTable?.details?.length > 3
                          ? "30vh"
                          : "unset",
                    }}
                  >
                    <Table className="table table-custom">
                      <thead>
                        <tr
                          style={{
                            position: "sticky",
                            top: "-1px",
                          }}
                        >
                          <td className="align-center"></td>
                          <td className="align-center">#</td>
                          {isTable?.headers?.map((h) => {
                            return <td className="align-center">{h?.label}</td>;
                          })}
                          <td className="align-center">Thao Tác</td>
                        </tr>
                      </thead>
                      <tbody>
                        {details?.length ? (
                          details?.map((item, index) => {
                            const getCellValue = (item, h) => {
                              if (Array.isArray(h?.value)) {
                                return h.value
                                  .map((v) => item?.[v] || "")
                                  .join("\n");
                              }
                              return item?.[h?.value] ?? "";
                            };

                            return (
                              <tr key={index}>
                                <td>
                                  <input
                                    class="form-input mt-0"
                                    type="checkbox"
                                    checked={clones[index] || false}
                                    onClick={(e) => {
                                      const { checked } = e.target;
                                      setClones((prev) => {
                                        const newPrev = { ...prev };
                                        newPrev[index] = checked;
                                        return newPrev;
                                      });
                                    }}
                                  />
                                </td>
                                <td className="align-center">{index + 1}</td>
                                {isTable?.headers?.map((h, i) => {
                                  const val = getCellValue(item, h);

                                  const cellStyle = {
                                    color: h?.color,
                                    whiteSpace: "pre",
                                    ...h?.styles,
                                  };

                                  let content = val;
                                  if ((isCreate || isUpdate) && !h?.readOnly) {
                                    content = (
                                      <input
                                        className="form-control"
                                        value={dataTable?.[index]?.[h.value]}
                                        step="any"
                                        type={h?.type}
                                        min={0}
                                        onChange={(e) => {
                                          const { value } = e.target;

                                          setDataTables((prev) => {
                                            const newPrev = [...prev];

                                            newPrev[index] = {
                                              ...newPrev[index],
                                              [h?.value]: value,
                                            };
                                            return newPrev;
                                          });
                                        }}
                                      />
                                    );
                                  }

                                  return (
                                    <td
                                      key={i}
                                      className="align-center"
                                      style={cellStyle}
                                    >
                                      {content}
                                    </td>
                                  );
                                })}
                                <td className="align-center">
                                  <button
                                    className="btn btn-danger"
                                    onClick={() => {
                                      setDataTables((prev) =>
                                        prev.filter((_, i) => i !== index)
                                      );
                                      setSelectedValues((prev) => {
                                        const newPrev = { ...prev };

                                        const remainingMathanhpham = new Set(
                                          dataTable.map(
                                            (item) => item.mathanhpham
                                          )
                                        );

                                        newPrev[alias] = (
                                          newPrev[alias] || []
                                        ).filter((v) =>
                                          remainingMathanhpham.has(v.value)
                                        );

                                        setValue(
                                          alias,
                                          (newPrev[alias] || []).map(
                                            (i) => i.value
                                          )
                                        );
                                        console.log("newPrevnewPrev",dataTable, newPrev,remainingMathanhpham)
                                        return newPrev;
                                      });
                                    }}
                                    type="button"
                                  >
                                    <FontAwesomeIcon icon={faTrashCan} />
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td
                              colSpan={isTable?.headers?.length + 2}
                              className="align-center"
                            >
                              {lang["not found data"]}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                )}
              </>
            );
          }}
        />
      );

    case "textarea":
      return (
        <textarea
          rows={4}
          {...register(alias)}
          className="form-control"
          readOnly={readOnly}
        />
      );

    case "number":
      return Input(isDisabled, type, alias, register, readOnly, 0);
    case "float":
      return Input(
        isDisabled,
        type,
        alias,
        register,
        readOnly,
        0,
        "any",
        setValue
      );
    case "file":
      const files = getValues(alias);
      return (
        <FileImageUpdate
          key={refresh}
          field={alias}
          changeTrigger={(e, value) => {
            setValue(alias, value);
          }}
          defaultValue={files}
          isMultiple={true}
          col="col-sm-12"
          refresh={refresh}
          isCustom={true}
        />
      );
    case "text":
    default:
      return Input(isDisabled, type, alias, register, readOnly);
  }
}

const loadOptions = async (
  page = 0,
  search = "",
  displayFields,
  table_id,
  proxy,
  isPK,
  isApi,
  isClone
) => {
  return new Promise(async (resolve, reject) => {
    let dataBody = {
      table_id,
      start_index: page,
      type: "or",
    };

    let newData = {
      options: [],
      hasMore: false,
      additional: {
        page: 0,
      },
    };
    if (search) {
      let criteria = {};
      let criteria_type = {};
      displayFields.forEach((field) => {
        criteria[field] = search.trim();
        criteria_type[field] = "regex";
      });

      dataBody.criteria = criteria;
      dataBody.criteria_type = criteria_type;
    }

    const _token = localStorage.getItem("_token");
    try {
      const { data } = isApi
        ? await fetch(proxy() + isApi, {
            method: "POST",
            headers: {
              Authorization: _token,
              "content-type": "application/json",
              "data-amount": 100,
            },
            body: JSON.stringify({
              ...dataBody,
              skip: page,
              limit: 100,
            }),
          }).then((res) => res.json())
        : await ForeignData_API.get(proxy(), _token, dataBody);
      let hasMoreValue = true;

      if (!data?.length) {
        hasMoreValue = false;
      }

      if (data.length) {
        const options = data.flatMap((item) => {
          const hasArrayField = displayFields.find((field) =>
            Array.isArray(item[field])
          );
          if (!hasArrayField) {
            return [
              {
                label: displayFields
                  .map((field) => item[field])
                  .filter(Boolean)
                  .join("|"),
                value: item?.[isPK],
                ...item,
              },
            ];
          }

          const arrayField = hasArrayField;
          const arrayValues = item[arrayField];

          return !isClone
            ? [
                {
                  label: displayFields
                    .map((field) => item[field])
                    .filter(Boolean)
                    .join("|"),
                  value: item?.[isPK],
                  ...item,
                },
              ]
            : arrayValues.map((val) => {
                const clonedItem = { ...item, [arrayField]: val };
                return {
                  label: displayFields
                    .map((field) => clonedItem[field])
                    .filter(Boolean)
                    .join("|"),
                  value: clonedItem?.[isPK],
                  ...clonedItem,
                };
              });
        });
        const pageNum = isApi ? 100 : 15;

        newData = {
          options,
          hasMore: hasMoreValue,
          additional: {
            page: hasMoreValue ? page + pageNum : page,
          },
        };
      }

      setTimeout(() => {
        resolve(newData);
      }, 100);
    } catch (error) {
      console.error("Error in loadOptions:", error);
      reject(error);
    }
  });
};

const Input = (
  isDisabled,
  type,
  alias,
  register,
  readOnly,
  min,
  step,
  setValue
) => {
  return (
    <input
      {...register(alias, { valueAsNumber: type === "number" })}
      type={type === "float" ? "number" : type}
      className="form-control"
      readOnly={readOnly}
      min={min}
      step={step}
      onBlur={(e) => {
        const { value } = e.target;
        if (type === "float" && value) {
          const roundedValue = parseFloat(value).toFixed(3);
          const parseValue = Number(roundedValue);
          setValue(alias, parseValue);
        }
      }}
      disabled={isDisabled?.[alias] || false}
      // max="999"
      // maxLength="3"
    />
  );
};
